import React, { useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";
import moment from "moment-timezone";
import ModalFormEntranceExamSchedule from "./components/ModalFormEntranceExamSchedule";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend(isSameOrAfter);

export default function PageEntranceExamCalendar(props) {
	const { dataSource } = props;

	moment.tz.setDefault("Asia/Manila");
	const calendarRef = useRef(null);

	const [
		toggleModalFormEntranceExamSchedule,
		setToggleModalFormEntranceExamSchedule,
	] = useState({
		open: false,
		data: null,
	});

	let eventCount = 0;

	const currentDate = dayjs().startOf("day");

	const eventData = dataSource.data.data.map((item) => {
		const {
			exam_date,
			available_slots,
			slots,
			time_in,
			time_in_meridiem,
			time_out,
			time_out_meridiem,
		} = item;

		const isBeforeCurrentDate = dayjs(exam_date).isBefore(currentDate);

		return {
			title: `Exam Schedule  ${available_slots} / ${slots}`,
			time: `( ${time_in} ${time_in_meridiem} - ${time_out} ${time_out_meridiem} )`,
			start: dayjs(
				`${exam_date} ${time_in} ${time_in_meridiem}`,
				"YYYY-MM-DD hh:mm A"
			).format("YYYY-MM-DD HH:mm:ss"),
			end: dayjs(
				`${exam_date} ${time_out} ${time_out_meridiem}`,
				"YYYY-MM-DD hh:mm A"
			).format("YYYY-MM-DD HH:mm:ss"),
			color: isBeforeCurrentDate
				? "grey"
				: available_slots === 0
				? "#FE0000"
				: "green",
			classNames: isBeforeCurrentDate
				? "disable-exam-date"
				: available_slots === 0
				? "no-available"
				: "available",
			item: item,
		};
	});

	const currentDay = new Date().toLocaleString("en-us", {
		weekday: "short",
	});

	// Set default time 08:00 AM - 12:00 PM
	const onSelectDate = (arg) => {
		const startDate = dayjs(arg.startStr);

		setToggleModalFormEntranceExamSchedule({
			open: true,
			data: {
				exam_date: startDate.format("YYYY-MM-DD"),
				time_in: startDate
					.set("hour", 8)
					.set("minute", 0)
					.format("HH:mm"),
				time_out: startDate
					.set("hour", 12)
					.set("minute", 0)
					.format("HH:mm"),
				time_in_meridiem: startDate.format("A"),
				time_out_meridiem: "PM", // Explicitly set to "PM"
			},
		});
	};

	return (
		<>
			<div className="container-exam-calendar">
				<FullCalendar
					// ref to the calendar to access the calendar object
					ref={calendarRef}
					height={650}
					dayMaxEvents={true}
					displayEventTime={false}
					events={eventData}
					eventContent={(arg) => {
						const { event } = arg;
						const { title } = event._def;
						const { color } = event._def.ui;
						const { time } = event._def.extendedProps;

						return (
							<div
								className="event-content"
								style={{
									backgroundColor: color,
									borderRadius: "5px",
									padding: "5px",
									color: "white",
								}}
							>
								{title}
								<br />
								{time}
							</div>
						);
					}}
					plugins={[
						dayGridPlugin,
						timeGridPlugin,
						interactionPlugin,
						multiMonthPlugin,
					]}
					headerToolbar={{
						left: "prev,today,next",
						center: "title",
						right: "dayGridMonth,timeGridWeek,timeGridDay",
					}}
					views={{
						dayGridMonth: {},
						timeGridWeek: {
							nowIndicator: true,
							slotMinTime: "06:00:00",
							slotMaxTime: "22:00:00",
						},
						timeGridDay: {
							nowIndicator: true,
							slotMinTime: "06:00:00",
							slotMaxTime: "22:00:00",
						},
					}}
					eventDidMount={({ event }) =>
						moment(event.start).isSame(new Date(), "day") && eventCount++
					}
					datesSet={({ startStr, endStr, args }) => {
						document
							// highlight the current day, by adding a class to the header
							.querySelectorAll(".fc-col-header-cell")
							.forEach(
								(header) =>
									header.textContent === currentDay &&
									header.classList.add("current-day-header")
							);

						const start = new Date(startStr);

						document.querySelectorAll(".fc-day").forEach((cell, index) => {
							const date = new Date(
								start.getTime() + index * 24 * 60 * 60 * 1000
							);

							if (calendarRef.current) {
								const eventsOnThisDay = calendarRef.current
									.getApi()
									.getEvents()
									.filter((event) => event.start.getDate() === date.getDate());
								if (eventsOnThisDay.length > 0) {
									const badge = Object.assign(document.createElement("badge"), {
										className: "badge",
									});

									// Reset event count
									const countTextElement = cell.querySelector(".countText");
									const badgeElement = cell.querySelector(".badge");
									if (countTextElement) countTextElement.remove();
									if (badgeElement) badgeElement.remove();

									cell.append(badge);

									if (
										calendarRef.current.getApi().view.type !== "dayGridMonth"
									) {
										const countText = Object.assign(
											document.createElement("span"),
											{
												className: "countText",
												textContent: ` ${eventsOnThisDay.length} Schedule`,
											}
										);
										cell.append(countText);
									}
								}
							}
						});
					}}
					dayCellClassNames={(arg) => {
						if (dayjs(arg.date).isBefore(currentDate)) {
							return "fc-day-disabled";
						}
					}}
					selectable={true}
					selectAllow={(selectInfo) => {
						return dayjs(selectInfo.start).isSameOrAfter(currentDate); // Date before current is not selectable
					}}
					select={onSelectDate}
					eventClick={(arg) => {
						let item = arg.event.extendedProps.item;

						setToggleModalFormEntranceExamSchedule({
							open: true,
							data: item,
						});
					}}
				/>
			</div>

			<ModalFormEntranceExamSchedule
				toggleModalFormEntranceExamSchedule={
					toggleModalFormEntranceExamSchedule
				}
				setToggleModalFormEntranceExamSchedule={
					setToggleModalFormEntranceExamSchedule
				}
			/>
		</>
	);
}
